export default __webpack_public_path__ + "static/media/49.2cf8efef.jpeg";